import clsx from "clsx";
import React from "react";
import styles from "./switch.module.css";

interface SwitchProps {
    ariaLabelledby?: string;
    selected: boolean;
    disabled: boolean;
    onChange: (newState: boolean) => void;
}

export default function Switch({
    ariaLabelledby = "",
    selected = false,
    disabled = false,
    onChange = (): void => {},
}: SwitchProps): JSX.Element {
    return (
        <div
            aria-labelledby={ariaLabelledby}
            className={clsx(
                styles.toggle,
                { [styles.selected]: selected },
                { [styles.disabled]: disabled }
            )}
            onClick={(): void => {
                onChange(!selected);
            }}
        >
            <div className={styles.toggleButton} />
        </div>
    );
}
